import { Box } from '@zillow/constellation-10';
import Image from 'next/image';
import starSvg from '../../images/star.svg';

export default function IconStarsGroup({ isGroupOfThreeStars }: { isGroupOfThreeStars: boolean }) {
  return (
    <>
      {isGroupOfThreeStars ? (
        <Box css={{ position: 'relative', height: '100px', width: '75px' }}>
          <Image
            src={starSvg}
            alt="Star"
            width={19}
            height={19}
            style={{ position: 'absolute', top: '5px', right: '5px' }}
          />
          <Image
            src={starSvg}
            alt="Star"
            width={31}
            height={32}
            style={{ position: 'absolute', top: '20px', left: 0 }}
          />
          <Image
            src={starSvg}
            alt="Star"
            width={51}
            height={52}
            style={{ position: 'absolute', bottom: 0, right: 0 }}
          />
        </Box>
      ) : (
        <Box css={{ position: 'absolute', height: '70px', width: '50px' }}>
          <Image
            src={starSvg}
            alt="Star"
            width={22}
            height={22}
            style={{ position: 'absolute', top: '0', left: '0' }}
          />
          <Image
            src={starSvg}
            alt="Star"
            width={36}
            height={36}
            style={{ position: 'absolute', bottom: '0', right: '0' }}
          />
        </Box>
      )}
    </>
  );
}
